import instance from './instance';

const STATION_BASE_URL = 'station';
export const STATION_FILTERED_URL =
  '/#/station?filter=%7B"status"%3A"ON"%2C"availableLessThan"%3A3%7D&order=DESC&page=1&perPage=10&sort=available';

export function ejectBySlot(stationId, slot) {
  return instance.post(`${STATION_BASE_URL}/${stationId}/eject/?slot=${slot}`);
}
